export type {Shop, ShopType} from "./model/types";
export {SHOP_TYPE} from "./model/types";
import {ShopHttpRepository} from "./api/ShopHttpRepository";
import {createShopStore} from "./model/store";

const shopRepository = new ShopHttpRepository();

export const useShopStore = createShopStore({
    repository: shopRepository,
});
